import React, { Component } from "react";
import { Container } from "reactstrap";
import FormAlumnoExpress from "./FormAlumnoExpress";
import { connect } from "react-redux";
import { postAlumnoCreate } from "./AlumnoAction";
import swal from "sweetalert";
import { withRouter } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import { Link } from "react-router-dom";

import getMuiTheme from 'material-ui/styles/getMuiTheme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

const mapStateToProps = (state) => {
	return {
		getResponDataAlumnoC: state.AlumnoReducer.getResponDataAlumnoC,
		errorResponAlumnoC: state.AlumnoReducer.errorResponAlumnoC,
	};
};

class AlumnoCreateContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
		};
	}


	handleSubmit(data) {
		this.props.dispatch(postAlumnoCreate(data));
	}

	render() {
		const { activeTab } = this.state

		if (this.props.getResponDataAlumnoC || this.props.errorResponDataAlumnoC) {

			if (this.props.errorResponDataAlumnoC) {
				swal("Fallido!", this.props.errorResponDataAlumnoC, "Error");
			} else {
				swal({
					title: "¡Alumno Creado!",
					icon: "success",
					button: "Enterado"
				}
				)
					.then((willDelete) => {
						this.props.history.push("/alumno");
					});
			}//END ELSE

		}//END IF

		return (
			<MuiThemeProvider muiTheme={getMuiTheme()}>

				<>
					<div className="section-body">
						<div className="container-fluid">
							<div className="d-flex justify-content-between align-items-center ">
								<div className="header-action">
									<h1 className="page-title">Alumno</h1>
									<ol className="breadcrumb page-breadcrumb">
										<li className="breadcrumb-item"><a href="#">Escolar</a></li>
										<li className="breadcrumb-item active" aria-current="page">CREAR</li>
									</ol>
								</div>
								<Nav tabs className="page-header-tab">
									<NavItem>
										<Link to={"/alumno"}>Listar Alumno</Link>
									</NavItem>
								</Nav>

							</div>
						</div>
					</div>

					<div className="section-body mt-4">
						<div className="container-fluid">
							<TabContent activeTab={activeTab}>

								<TabPane tabId={1} className={classnames(['fade show'])}>


									<div className="row clearfix">
										<div className="col-lg-12 col-md-12 col-sm-12">
											<div className="card">
												<div className="card-header">
													<h3 className="card-title">Crear Alumno IEC</h3>
													<div className="card-options ">
														<a href="#" className="card-options-collapse" data-toggle="card-collapse"><i className="fe fe-chevron-up"></i></a>
														<a href="#" className="card-options-remove" data-toggle="card-remove"><i className="fe fe-x"></i></a>
													</div>
												</div>

												<FormAlumnoExpress onSubmit={(data) => this.handleSubmit(data)} />

											</div>
										</div>

									</div>

								</TabPane>


							</TabContent>
						</div>
					</div>

				</>

			</MuiThemeProvider>
		);

	}// END RENDER



}//END CLASS

export default connect(mapStateToProps, null)(AlumnoCreateContainer);